import React, { Children, useState, cloneElement, SetStateAction } from 'react';
import s from './Accordion.module.scss';
import {
  CaretDownIcon,
  useAttribute,
  useThreekitInitStatus,
} from '@threekit-tools/treble';
import { AttributesT } from '../../utils/constants';
import { DefaultBtn } from '../../mainComponents/DefaultBtn/DefaultBtn';
import { useStoreDispatch } from '../..';
import { SetActiveItem } from '../../store/actions/Settings';
import PenSvg from './../../assets/PenSvg';
import { replaceStaticName } from '../../utils/helpFunctions';
import { getActualPrice } from '../../mainComponents/AttributeComponents/Product';
import { useEffect } from 'react';
import Error from '../../assets/Error';

type AccordionItemT = {
  selected?: boolean;
  handleSelect?: any;
  label: string;
  activeItem: string;
  defaultItem: string;
  actualName: AttributesT;
  children: React.ReactChild;
  cameraPosition: number;
};

export function AccordionItem(props: AccordionItemT) {
  const {
    selected,
    handleSelect,
    label,
    activeItem,
    defaultItem,
    actualName,
    children,
    cameraPosition,
  }: AccordionItemT = props;
  const hasLoaded = useThreekitInitStatus();
  const [attribute, setAttribute]: any = useAttribute(actualName);

  const isAssetType = attribute.type === 'Asset';
  const value = isAssetType ? attribute.value.assetId : attribute.value;
  const defaultValue = isAssetType
    ? attribute.defaultValue.assetId
    : attribute.defaultValue;
  const defaultIsActive = value !== defaultValue;
  const dispatch = useStoreDispatch();
  let title =
    replaceStaticName(activeItem) === 'Standart'
      ? 'None'
      : replaceStaticName(activeItem);
  function toDefault(e: any, value: any) {
    e.stopPropagation();

    dispatch(
      SetActiveItem({
        name: actualName,
        data: {
          activeItem: defaultItem,
          activeItemId: undefined,
          price: 0,
          shopInfo: { quantity: 1 },
        },
      })
    );
    setAttribute(value);
  }

  useEffect(() => {
    if (hasLoaded && selected && cameraPosition != undefined) {
      // TODO: Implement camera position change in PlayCanvas
      // @ts-ignore
      // window.playerT.configurator.setConfiguration({
      //   'Camera Position': cameraPosition,
      // });
    }
  }, [selected]);
  return (
    <div className={`${s.accordion__wrapper} ${selected ? s.active : ''}`}>
      <div onClick={handleSelect} className={s.accordion_item}>
        {/* {defaultIsActive && (
          <div className={s.accordion_default}>
            <DefaultBtn toDefault={toDefault} attribute={attribute} />
          </div>
        )} */}
        <div className={s.accordion_info}>
          <div className={s.accordion_title}>{label}</div>
          {title !== 'None' && (
            <div className={`${s.accordion_subtitle} ${title && s.visible}`}>
              {title}
            </div>
          )}
        </div>
        {defaultIsActive ? (
          <div className={`${s.accordion_arrow} ${s.pen}`}>
            <PenSvg />
          </div>
        ) : (
          <div className={`${s.accordion_arrow} ${s.default}`}>
            <CaretDownIcon />
          </div>
        )}
      </div>
      <div className={s.accordion_content}>
        <div className={s.accordion_children}>{children}</div>
      </div>
    </div>
  );
}

function Accordion(props: any) {
  const [selected, setSelected] = useState(undefined);

  const handleSelect = (idx: any) =>
    setSelected(idx === selected ? undefined : idx);

  if (!props.children) return null;

  return Children.map(props.children, (child, idx) => {
    if (child === null) return null;
    if (child.type !== AccordionItem) return null;
    return cloneElement(child, {
      selected: selected === idx,
      handleSelect: () => {
        if (child.props.onClick) child.props.onClick();
        handleSelect(idx);
      },
    });
  });
}

Accordion.AccordionItem = AccordionItem;

export default Accordion;
